export default "__VITE_ASSET__DBZHc76W__"